export type ErrorResponse = Error & { status: number }

function isErrorResponse(error: unknown): error is ErrorResponse {
  return (
    typeof error === 'object' &&
    error !== null &&
    'status' in error &&
    typeof (error as any).status === 'number'
  )
}

export function getErrorResponseCode(r: Error | null): number | undefined {
  if (!isErrorResponse(r)) {
    return undefined
  }
  return r.status
}
